module.exports = __webpack_public_path__ + "static/img/business-success.b4478830.png";